export const FETCH_LOAN_SETTLEMENTS = "FETCH_LOAN_SETTLEMENTS";
export const EDIT_LOAN_SETTLEMENT = "EDIT_LOAN_SETTLEMENT";
export const CLEAR_LOAN_SETTLEMENT = "CLEAR_LOAN_SETTLEMENT";
